// extracted by mini-css-extract-plugin
module.exports = {"table":"D333aaes","withBodyRowHover":"RskSut_I","isHeaderSticky":"Avfj_OsW"};